"use strict";
/**
 * Functions for reading/writing user items to dynamodb
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetWlfTable = GetWlfTable;
exports.GetSaTable = GetSaTable;
exports.CreateItemKey = CreateItemKey;
exports.CreateItemLut = CreateItemLut;
exports.GetUserItems = GetUserItems;
exports.GetUserItemsC = GetUserItemsC;
exports.UpdateUserItem = UpdateUserItem;
exports.UpdateUserItemC = UpdateUserItemC;
var aws_dynamo_1 = require("@ca/wrap-sdk/src/aws-dynamo");
var response_1 = require("@ca/wrap-sdk/src/response");
var aws_cognito_1 = require("@ca/wrap-sdk/src/aws-cognito");
var response_2 = require("@ca/wrap-sdk/src/response");
var env_1 = require("@ca/wrap-sdk/src/env");
var sprintf_js_1 = require("sprintf-js");
function GetWlfTable(wlf_id) {
    return env_1.Stage.stage + "-" + wlf_id;
}
function GetSaTable() {
    return env_1.Stage.stage + "-super-admin";
}
function CreateItemKey(user, label, index) {
    var confirmed = user.confirmed;
    var username = user.username;
    var identity_id = user.identity_id;
    var key;
    if (Number.isInteger(index)) {
        key = (0, sprintf_js_1.sprintf)("%s_%04d", label, index);
    }
    else {
        key = label;
    }
    if (confirmed) {
        return {
            partition: identity_id,
            id: key,
        };
    }
    else {
        return {
            partition: key,
            id: username,
        };
    }
}
function CreateItemLut(user, labels, items) {
    var result = {};
    var prop;
    if (!user) {
        // If no user, assume confirmed.
        prop = 'id';
    }
    else {
        prop = user.confirmed ? 'id' : 'partition';
    }
    var re = /^(.+)_\d+$/;
    items.forEach(function (item) {
        labels.forEach(function (label) {
            var match = item[prop].match(re);
            if (match && match.length >= 2 && match[1] === label) {
                result[label] = item;
            }
            else if (item[prop] === label) {
                result[label] = item;
            }
        });
    });
    return result;
}
function GetUserItems(username, labels, index) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, GetUserItemsC(null, username, labels, index)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function GetUserItemsC(creds, username, labels, index) {
    return __awaiter(this, void 0, void 0, function () {
        var resp, keys, table, user, sa_table, identity_id_key, resp_1, id_items, identity_id_1, wlf_id, id_1, batch_resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, aws_cognito_1.AdminGetUserC)(creds, username)];
                case 1:
                    resp = _a.sent();
                    user = null;
                    if (!(resp.status === response_2.Status.OK)) return [3 /*break*/, 2];
                    user = resp.payload;
                    table = GetWlfTable(user.wlf_id);
                    keys = labels.map(function (label) { return CreateItemKey(user, label, index); });
                    return [3 /*break*/, 4];
                case 2:
                    sa_table = GetSaTable();
                    identity_id_key = {
                        partition: "developer-identity-id",
                        id: username,
                    };
                    return [4 /*yield*/, (0, aws_dynamo_1.BatchC)(creds, sa_table, [identity_id_key])];
                case 3:
                    resp_1 = _a.sent();
                    if (resp_1.status === response_2.Status.ERROR) {
                        resp_1 = (0, response_1.ErrorResponse)("Can't find user " + username);
                        return [2 /*return*/, resp_1];
                    }
                    id_items = resp_1.payload;
                    if (id_items.length === 0) {
                        // User does not exist.
                        return [2 /*return*/, (0, response_1.ErrorResponse)({
                                msg: "Username does not exist",
                                username: username,
                            })];
                    }
                    identity_id_1 = id_items[0].identity_id;
                    wlf_id = username.split("_")[0];
                    table = GetWlfTable(wlf_id);
                    keys = [];
                    labels.forEach(function (label) {
                        if (Number.isInteger(index)) {
                            id_1 = (0, sprintf_js_1.sprintf)("%s_%04d", label, index);
                        }
                        else {
                            id_1 = label;
                        }
                        keys.push({
                            partition: identity_id_1,
                            id: id_1,
                        });
                    });
                    _a.label = 4;
                case 4: return [4 /*yield*/, (0, aws_dynamo_1.BatchC)(creds, table, keys)];
                case 5:
                    batch_resp = _a.sent();
                    if (batch_resp.status === response_2.Status.ERROR) {
                        return [2 /*return*/, batch_resp];
                    }
                    return [2 /*return*/, (0, response_2.SuccessResponse)(CreateItemLut(user, labels, batch_resp.payload))];
            }
        });
    });
}
function UpdateUserItem(username, label, index, return_item, data, paths) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, UpdateUserItemC(null, username, label, index, return_item, data, paths)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function UpdateUserItemC(creds, username, label, index, return_item, data, paths) {
    return __awaiter(this, void 0, void 0, function () {
        var table, key, resp, user, sa_table, identity_id_key, resp_2, identity_id, wlf_id, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, aws_cognito_1.AdminGetUserC)(creds, username)];
                case 1:
                    resp = _a.sent();
                    if (!(resp.status === response_2.Status.OK)) return [3 /*break*/, 2];
                    if (!label) {
                        resp = (0, response_1.ErrorResponse)("No label defined");
                        console.log(resp);
                        return [2 /*return*/, resp];
                    }
                    user = resp.payload;
                    table = GetWlfTable(user.wlf_id);
                    key = CreateItemKey(user, label, index);
                    return [3 /*break*/, 4];
                case 2:
                    sa_table = GetSaTable();
                    identity_id_key = {
                        partition: "developer-identity-id",
                        id: username,
                    };
                    return [4 /*yield*/, (0, aws_dynamo_1.BatchC)(creds, sa_table, [identity_id_key])];
                case 3:
                    resp_2 = _a.sent();
                    if (resp_2.status === response_2.Status.ERROR) {
                        return [2 /*return*/, (0, response_1.ErrorResponse)("Can't find user " + username)];
                    }
                    if (resp_2.payload.length === 0) {
                        return [2 /*return*/, (0, response_1.ErrorResponse)({
                                msg: "Username does not exist",
                                username: username,
                            })];
                    }
                    identity_id = resp_2.payload[0].identity_id;
                    wlf_id = username.split("_")[0];
                    table = GetWlfTable(wlf_id);
                    if (Number.isInteger(index)) {
                        key = {
                            partition: identity_id,
                            id: (0, sprintf_js_1.sprintf)("%s_%04d", label, index),
                        };
                    }
                    else {
                        key = {
                            partition: identity_id,
                            id: label,
                        };
                    }
                    _a.label = 4;
                case 4:
                    if (!data) return [3 /*break*/, 6];
                    return [4 /*yield*/, (0, aws_dynamo_1.UpdateC)(creds, table, key, data, [], return_item ? "ALL_NEW" : null)];
                case 5:
                    response = _a.sent();
                    return [3 /*break*/, 9];
                case 6:
                    if (!paths) return [3 /*break*/, 8];
                    return [4 /*yield*/, (0, aws_dynamo_1.UpdatePathsC)(creds, table, key, paths, return_item ? "ALL_NEW" : null)];
                case 7:
                    response = _a.sent();
                    return [3 /*break*/, 9];
                case 8:
                    response = (0, response_1.ErrorResponse)("No data or paths " + JSON.stringify(event, null, 2));
                    _a.label = 9;
                case 9: return [2 /*return*/, response];
            }
        });
    });
}
//# sourceMappingURL=item-io.js.map